<script setup lang="ts">
import {LegacyStateTransition} from '@hantera/portal-app';


const props = defineProps<{
  data: LegacyStateTransition
}>();

// TODO: Add localization

</script>

<template>
  <div class="timeline-order-state-change">
    Order state changed from <span
      class="timeline-order-state-change__state"
      :style="`background-color: var(--state-colors__order-${data.fromState?.toLowerCase()})`"
    >{{ data.fromState }}</span> to <span
      class="timeline-order-state-change__state"
      :style="`background-color: var(--state-colors__order-${data.toState?.toLowerCase()})`"
    >{{ data.toState }}</span>
  </div>
</template>

<style>
.timeline-order-state-change {
  max-width: 800px;
  margin-top: -4.5px;
}

.timeline-order-state-change__color-indicator {
  display: inline-block;
  width: 5px;
  border-radius: 5px;
  height: 20px;
  vertical-align: sub;
  margin: 0 2px;
}

.timeline-order-state-change__timestamp,
.timeline-order-state-change__number {
  font-weight: 600;
}

.timeline-order-state-change__state {
  font-weight: 600;
  color: white;
  display: inline-block;
  padding: 4px 4px 3px 4px;
  border-radius: 4px;
}
</style>